<template>
   <div>
      <p class="instructions">Send a notification upon these events...</p>
      <div class="pref-contain">
         <div v-for="(itm, indx) in prefs" :key="indx" >
            <div :class="'bkg bkg-' + ((indx % 2) + 1)" v-if="(!isVBAppointment && !isVBInvitation && !isVBCustomInvitation) ||
                                      ((isVBAppointment || isVBInvitation || isVBCustomInvitation) && itm.typ.vbAllowed)">

               <!-- Pref header Row -->
               <div class="row">
                  <div class="col-sm-8 font-weight-bold">{{ itm.typ.text }}</div>
                  <div class="col-sm-2 text-right">
                     Email
                     <label class="switch marl-12">
                        <input type="checkbox" class="success" v-model="itm.wantsEmail"
                           @change="switched($event, itm.typ.catkey, 'EMAIL_EVT')">
                        <span class="slider round"></span>
                     </label>
                  </div>
                  <div class="col-sm-2 text-right">
                     Text (SMS)
                     <label class="switch marl-12">
                        <input type="checkbox" class="success" v-model="itm.wantsSMS"
                           @change="switched($event, itm.typ.catkey, 'SMS_EVT')">
                        <span class="slider round"></span>
                     </label>
                  </div>
               </div>

               <!-- Pref Email Rows -->
               <div>
                  <div class="row">
                     <div class="col-sm-12">Email Addresses: <span class="text-muted font-smaller">(Enter up to 5 email
                           addresses separated by a comma)</span></div>
                  </div>
                  <div class="row">
                     <div class="col-sm-12">
                        <input type="text" style="width:100%" v-model="itm.email" :disabled="!itm.wantsEmail" />
                     </div>
                  </div>
               </div>

               <!-- Pref SMS Rows -->
               <div class="row mart-12">
                  <div class="col-sm-12">Phone Number to Text: <span class="text-muted font-smaller">(Enter up to 5
                        10-digit phone numbers separated by a comma)</span></div>
               </div>
               <div class="row">
                  <div class="col-sm-12">
                     <input type="text" style="width:100%" v-model="itm.sms" :disabled="!itm.wantsSMS" />
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="pref-buttons">
         <button type="button" class="btn ml-btn ml-bk-black ml-white ml-h-orange snc-btn"
            @click.prevent="cancelChanges">
            <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
            <span v-else>
               <i class="fas fa-times"></i>
               CANCEL
            </span>
         </button>
         &nbsp;
         <button type="button" class="btn ml-btn ml-bk-corp ml-white ml-h-black snc-btn" @click.prevent="saveChanges">
            <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
            <span v-else>
               <i class="fas fa-check"></i>
               SAVE
            </span>
         </button>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
   name: "CommPrefs",
   props: ['userId'],
   data() {
      return {
         loggit: false,
         extUserId: '',
         extUserName: '',
         subscriberId: 0,
         btnBusy: false,
         prefs: [],
         prefData: [],
         prefTypes: [
            {
               text: 'Submission of Prospect Appointment Application',
               catkey: 'CAT_APPSUB_RECRUIT',
               vbAllowed: true
            },
            {
               text: 'Approval of Prospect Appointment Application',
               catkey: 'CAT_APPAPRV_RECRUIT',
               vbAllowed: true
            },
            {
               text: 'Rejection of Prospect Appointment Application',
               catkey: 'CAT_APPREJ_RECRUIT',
               vbAllowed: true
            },
            {
               text: 'Abandonment of Prospect Appointment Application',
               catkey: 'CAT_APPABAND_RECRUIT',
               vbAllowed: true
            },
            {
               text: 'Submission of Downline Prospect Appointment Application',
               catkey: 'CAT_APPSUB_DOWNLN',
               vbAllowed: false
            },
            {
               text: 'Approval of Downline Prospect Appointment Application',
               catkey: 'CAT_APPAPRV_DOWNLN',
               vbAllowed: false
            },
            {
               text: 'Rejection of Downline Prospect Appointment Application',
               catkey: 'CAT_APPREJ_DOWNLN',
               vbAllowed: false
            },
            {
               text: 'Abandonment of Downline Prospect Appointment Application',
               catkey: 'CAT_APPABAND_DOWNLN',
               vbAllowed: false
            }
         ]

      }
   },
   async mounted() {
      this.btnBusy = true
      await this.loadPrefs()
      this.btnBusy = false
      },
   computed: {
      ...mapGetters(["isVBAppointment", "isVBInvitation", "isVBCustomInvitation"]),
      },
   methods: {
      async loadPrefs() {
         this.log(`calling getPreferences(${this.userId})`)
         await this.$user.getPreferences(this.userId)
            .then(
               resp => {
                  if (resp) {
                     this.log(`returned this from  getPreferences(${this.userId})`, resp)
                     this.subscriberId = resp.subscriberId
                     if (resp.preferences && resp.preferences.length > 0)
                        this.prefData = resp.preferences
                  }
               }
            )
            .catch(async (err) => {
               // A 404 response  means the subscriber does not exist and needs to be created
               if ((err.status && err.status == 404) || (err.response && 404 === err.response.status)) {
                  this.log('404 - subscriber not found')
                  this.log(`calling createSubscriber(${this.userId})`)
                  await this.$user.createSubscriber(this.userId)
                     .then(
                        resp => {
                           this.log(`returned this from createSubscriber(${this.userId})`, resp)
                           this.subscriberId = resp.subscriber.subscriberId
                           this.saving = false
                        }
                     )
                     .catch(async (err) => {                        
                        this.saving = false
                        this.$swal(
                           "Oops!",
                           "The system could not create the communications preference profile at this time.  We apologize for the inconvenience.  Please try again later. If this problem persists, please contact support.",
                           "error"
                        )
                     })
               } else {
                  this.saving = false
                  this.$swal(
                     "Oops!",
                     "The system could not retrieve preferences at this time.  We apologize for the inconvenience.  Please try again later. If this problem persists, please contact support.",
                     "error"
                  )
               }
            })

         this.prefs = []
         this.prefTypes.forEach((itm) => {
            let eml = this.prefData.find(o => o.categoryCode === itm.catkey && o.methodCode == 'EMAIL_EVT')
            let sms = this.prefData.find(o => o.categoryCode === itm.catkey && o.methodCode == 'SMS_EVT')
            let p = {
               typ: itm,
               wantsEmail: eml != null,
               wantsSMS: sms != null,
               email: eml == null ? '' : eml.preferenceValue,
               sms: sms == null ? '' : sms.preferenceValue
            }
            this.prefs.push(p)
         });

      },
      async savePrefs() {
         this.prefData = []
         this.prefs.forEach((itm) => {
            if (itm.wantsEmail) {
               let o = {
                  subscriberId: this.subscriberId,
                  categoryCode: itm.typ.catkey,
                  methodCode: 'EMAIL_EVT',
                  preferenceValue: itm.email
               }
               this.prefData.push(o)
            }
            if (itm.wantsSMS) {
               let o = {
                  subscriberId: this.subscriberId,
                  categoryCode: itm.typ.catkey,
                  methodCode: 'SMS_EVT',
                  preferenceValue: itm.sms
               }
               this.prefData.push(o)
            }
         })
         
         let payload = {
            subscriberId: this.subscriberId,
            preferences: this.prefData
         }
         this.log(`calling savePreferences(${JSON.stringify(payload)})`)
         await this.$user.savePreferences(payload)
            .then(
               resp => {
                  this.log(`returned from savePreferences() with this:`, resp)
                  if (resp && resp == true) {
                     this.$swal(
                        "Success!",
                        "The system saved the communications preferences successfully.",
                        "success"
                     ).then(r => {
                        this.$emit("on-done");
                     })
                  } else {
                     this.$swal(
                        "Oops!",
                        "The system could not save preferences at this time.  We apologize for the inconvenience.  Please try again later. If this problem persists, please contact support.",
                        "error"
                     )
                  }
               }
            )
            .catch(async (err) => {               
               this.$swal(
                  "Oops!",
                  "The system could not save preferences at this time.  We apologize for the inconvenience.  Please try again later. If this problem persists, please contact support.",
                  "error"
               )
            })
      },
      async saveChanges() {
         this.btnBusy = true

         if (!this.inputIsValid()) {
            this.btnBusy = false
            return
         }

         await this.savePrefs()
         this.btnBusy = false
      },
      async cancelChanges() {
         this.$emit("on-done");
      },
      inputIsValid() {
         let r = true

         // missing data?
         this.prefs.forEach((itm) => {
            itm.email = itm.email.replace(/\s+/g, '')
            itm.sms = itm.sms.replace(/\s+/g, '')
            if (itm.wantsEmail == true && itm.email.trim() == '') {
               r = false
               this.$swal(
                  "Missing info...",
                  `For this preference, <b>${itm.typ.text}</b>, email was turned on but no email addresses were supplied.`,
                  "error"
               )
            }
            if (itm.wantsSMS == true && itm.sms.trim() == '') {
               r = false
               this.$swal(
                  "Missing info...",
                  `For this preference, <b>${itm.typ.text}</b>, SMS was turned on but no phone numbers were supplied.`,
                  "error"
               )
            }
         })

         if (r) {
            this.prefs.forEach((itm) => {
               if (itm.wantsEmail) {
                  let emails = itm.email.split(',')
                  let em = 0
                  emails.forEach((eml) => {
                     if (eml.trim()!='') {
                        em++
                        if (!this.emailIsValid(eml)) {
                           r = false
                           this.$swal(
                              "Invalid Email Address",
                              `For this preference, <b>${itm.typ.text}</b>, please make corrections or remove this email address: ${eml}`,
                              "error"
                           )
                        }
                     }
                  })
                  if (em > 5) {
                     r = false
                     this.$swal(
                        "Too Many Emails",
                        `For this preference, <b>${itm.typ.text}</b>, please limit it to 5 email addresses max.`,
                        "error"
                     )
                  }
               }
               if (itm.wantsSMS) {
                  let smss = itm.sms.split(',')
                  let phk = 0
                  smss.forEach((sms) => {
                     if (sms.trim()!='') {
                        phk++
                        if (!this.phoneIsValid(sms)) {
                           r = false
                           this.$swal(
                              "Invalid Phone Number",
                              `For this preference, <b>${itm.typ.text}</b>, please make corrections or remove this phone number (10 digits required): ${sms}`,
                              "error"
                           )
                        }
                     }
                  })
                  if (phk > 5) {
                     r = false
                     this.$swal(
                        "Too Many Phone #s",
                        `For this preference, <b>${itm.typ.text}</b>, please limit it to 5 phone numbers max.`,
                        "error"
                     )
                  }
               }
            })
         }

         return r
      },
      phoneIsValid(phoneNumber) {
         let r = true
         let ph = phoneNumber.replace(/-/g, "").replace(/\(/g, "").replace(/\)/g, "").replace(/ /g, "");
         if (phoneNumber != "" && ph.length != 10) {
            r = false
         }
         return r
      },
      emailIsValid(input) {
         let r = true
         let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
         if (!input.match(validRegex)) {
            r = false
         }
         return r
      },
      switched(event, cat, meth) {
         let valu = event.target.checked
         // we want to blank out recipient fields if they disable that method of the preference
         let row = this.prefs.find(o => o.typ.catkey === cat)
         if (row && valu == false) {
            if (meth == 'EMAIL_EVT') {
               row.email = ''
            } else {
               row.sms = ''
            }
         }
      },
      log(txt, two) {
         if (this.loggit != true) return
      }
   }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/colors.scss';
@import '../assets/css/slider.scss';

.pref-contain {
   width: 100%;
   border: 1px solid $corp-color;
}

.pref-buttons {
   text-align: right;
   margin: 24px 0;
}

.pref-buttons button {
   width: 120px;
}

.bkg {
   padding: 12px;
}

.bkg-1 {
   background-color: #eee;
}

.bkg-2 {
   background-color: #fff;
}

input {
   font-family: 'Courier New', Courier, monospace, sans-serif;
   color: $corp-blue;
}

.instructions {
   font-style: italic;
   color: $corp-blue;
}
</style>